module.exports = __webpack_public_path__ + "img/TwoAxleTractorThreeAxleSemitrailer.f220cc46.svg";